import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/page.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import Catalog from '../catalog';
import IndustryResearchPDF from '../industry-research/index';
import HumanIndicatorPDF from '../human-indicator/index';
import HumanDemandPdf from '../human-demand';
import WealfareInsightPdf from '../wealfare-insight';
import PdfBottom from '../pdf-bottom';
import HotJobPDF from '../hot-job/pdf';
import SectionBoundary from './section-boundary';

interface IProps {}
interface IState {}

const Page = (props: IProps, state: IState) => {

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="index-pdf-page-100">
      <SectionBoundary name="目录"><Catalog /></SectionBoundary>
      <IndustryResearchPDF />
      <HumanIndicatorPDF />
      <HumanDemandPdf />
      <WealfareInsightPdf />
      <SectionBoundary name="热门岗位"><HotJobPDF /></SectionBoundary>
      <PdfBottom/>
    </section>
  );
};

export default observer(Page);
